module.exports = __webpack_public_path__ + "static/media/gastronomia.3823f116.svg";